import { theme } from '@dasa-health/alma-react'

const device = (value: string) => `@media screen and (min-width: ${value})`

const breakPoint = {
  tablet: device(theme.breakpoints[0]),
  desktop: device(theme.breakpoints[2]),
}

export default breakPoint
